import React from "react";
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
const Invoice = ({ selectedProduct }) => {
  const products = Array.isArray(selectedProduct) ? selectedProduct : []; // Ensure it's an array
  if (products.length === 0) return null;

  const totalAmount = products.reduce((sum, item) => sum + item.total, 0);
  const totalVAT = products.reduce((sum, item) => sum + item.vat, 0);
  const totalCount = products.length;

  return (
    <Box
      sx={{
        width: "96%",
        padding: 1,
        border: "1px solid #ccc",
        borderRadius: 1,
       
        textAlign: "center",
      }}
    >
      <TableContainer
        component={Paper}
        sx={{
          maxHeight: "100px",
          // Hide scrollbar
          scrollbarWidth: "none",           // Firefox
          "-ms-overflow-style": "none",     // IE and Edge
          "&::-webkit-scrollbar": { display: "none" }, // Chrome, Safari, Opera
        }}
      >
        <Table size="small" stickyHeader>
          <TableHead bgcolor="black">
            <TableRow sx={{ bgcolor: "black" }}>
              <TableCell sx={{ fontWeight: "bold", color: "black" }}>Item</TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "black" }}>Qty</TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "black" }}>VAT</TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "black" }}>Rate</TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "black" }}>Amount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {products.map((product, index) => (
              <TableRow key={index}>
                <TableCell sx={{ fontSize: "11px" }}>{product.name || product.item}</TableCell>
                <TableCell>{product.quantity}</TableCell>
                <TableCell>{product.vat}</TableCell>
                <TableCell>{product.price}</TableCell>
                <TableCell>{product.total}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box display="flex" justifyContent="space-between" mt={2} sx={{ borderTop: "1px solid black" }}>
        <Typography variant="body2">Tot Count: {totalCount}</Typography>
        <Typography variant="body2">VAT: {totalVAT}</Typography>
        <Typography variant="body2">Rs. {totalAmount}</Typography>
      </Box>
    </Box>
  );
};
export default Invoice;
